$(document).ready(() =>
{
    $(document).on("gform_confirmation_loaded",  (e, form_id) => {
        const protectedDownloadsFormID = parseInt($("[data-protected-downloads-form-id]").data("protected-downloads-form-id"));
        const isProtectedDownloadsForm = !!protectedDownloadsFormID && (parseInt(form_id) === protectedDownloadsFormID);
        if(isProtectedDownloadsForm){
            $("body").addClass("have-restricted-access");
            setCookie('have_restricted_access', true, 60 * 60 * 24 * 365);

            window.applyDataTables();

            const $protectedDownloadModals = $(".protected-downloads-modal");
            $protectedDownloadModals.each((index, element) => {
                const modal = bootstrap.Modal.getOrCreateInstance(element);
                if(modal.hide){
                    modal.hide()
                }

            })
        }
    });

});